<template>
  <div class="wrapper">
    <notifications />
    <!--TODO: 通知は未実装。そもそも他にトップナビバーに何か入れるものはないのか？ -->
    <div class="content-container" :style="{ 'grid-template-columns': computedColumnWidths }">
      <side-bar id="sidebar" class="content-container__sidebar" @toggle-hide-mode="onClickSideBar" />
      <div class="content-container__main-panel main-panel">
        <dashboard-content />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import processAfterLogin from '@/appLogic/initializers/processAfterLogin';
import DashboardContent from './Content.vue';
import { i18n } from '@/i18n';
import { isInitialized } from '@/initProcess';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { provideLoadingStore } from '@/injectStore/loadingStore';
import { reactive, computed, onMounted } from 'vue';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import SideBar from '@/components/SidebarPlugin/SideBar.vue';
// マイナス在庫確認をONにするかどうか
const minusCheckerValid = true; // とりあえず諸々パスするまでfalse

const sleep = (ms: number) =>
  new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

provideLoadingStore();
const state = reactive<Record<string, any>>({
  isReady: false, // 初期化完了したらtrue
  showSidebar: false, // TODO: もしサイドバーをon/offしたいなら、widthの変更も必要
  sidebarBackground: 'main',
  sidebarBackgroundImage: require('@/assets/img/sidebar-2.jpg'),
  calendarChecker: false,
  minusBusinessChecker: false,
  minusErrors: { state: true, errors: [] } as { state: boolean; errors: IBusiness[] },
  calendarFails: [],
  checkCalendarOkButtonStr: String(i18n.t('稼働日を指定する')),
  checkCalendarCancelButtonStr: String(i18n.t('全日程稼働日にする')),
  // とりあえずdataで定義しておく
  store: useStore(),
  router: useRouter(),
  route: useRoute(),
}) as Record<string, any>;

const computedColumnWidths = computed(() => {
  const sideBarWidth = state.showSidebar ? '140px' : '70px';
  return `${sideBarWidth} minmax(0, 1fr)`;
});

onMounted(async () => {
  do {
    await sleep(50);
  } while (!isInitialized()); // 初期化完了まで待つ
  await processAfterLogin(); // Layoutが表示されているということは、つまりログインが完了しているということ

  state.isReady = true;
});
const onClickSideBar = () => {
  state.showSidebar = !state.showSidebar;
};
</script>

<style lang="scss" scoped>
/* TODO:  ここ、baseWidthとかからとってきたいが、上手くいかないので一旦直接書いておく */
.wrapper {
  min-width: 1680px;
  min-height: 800px;
  height: 100vh; /* 縦幅は余白を残さず画面いっぱいに表示する */
}

.content-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);

  &__sidebar {
    grid-column: 1 / 2;
    height: 100%;
    min-width: 70px;
  }
  &__main-panel {
    grid-column: 2 / 3;
    min-height: 100%;
    max-height: 100%;
    background-color: $backgroundPrimary;
    width: 100%;
  }
}
.calendar-checker {
  text-align: center;
  display: grid;
  margin-bottom: 15px;
}
</style>
